<button
    class="grid w-full cursor-pointer grid-cols-[auto_1fr_auto] py-3"
    (click)="select.emit(searchItem)"
    role="button"
    tabindex="0">
    <div class="flex-justify-center flex-align-center flex h-full w-full">
        <ion-icon
            class="vl-app-light:text-black var-app-light:text-grey-zambezy hu-light:text-black orb-app-light:text-secondary orb-app-dark:text-contrast-yellow h-8 w-8 rounded text-white"
            *ngIf="searchItem.type === 'STOP'"
            [src]="(assetsPath$ | async) + '/img/explore/bus.svg'"
            [attr.aria-label]="'STOP' | translate"></ion-icon>
        <ion-icon
            class="vl-app-light:text-black vl-app-light-dark:h-8 vl-app-light-dark:w-8 var-app-light:text-grey-zambezy orb-app-light:text-grey-zambezy h-8 w-8 dark:filter-yellow"
            *ngIf="searchItem.type === 'LOCATION'"
            [src]="addressIcon"
            [attr.aria-label]="'PH_ADDRESS' | translate"></ion-icon>
        <ion-icon
            class="vl-app-light:text-black var-app-light:text-grey-zambezy orb-app-light:text-grey-zambezy h-8 w-8 dark:filter-yellow"
            *ngIf="searchItem.type === 'POI'"
            [src]="poiIcon"
            [attr.aria-label]="'POI' | translate"></ion-icon>
        <ng-container *ngIf="searchItem.type === 'ROUTE'">
            <span class="sr-only">{{ searchItem.shortName }}</span>
            <div
                class="flex-align-center flex-justify-center pn-dark:!bg-white pn-dark:!text-black var-app-light:text-grey-zambezy flex h-[1.75rem] w-fit min-w-[1.75rem] rounded-2xl font-bold leading-5 text-white"
                [ngClass]="[
                    searchItem.shortName.length > 3 ? 'px-1.5' : '',
                    searchItem.shortName.length > 6 ? 'text-[0.625rem]' : 'text-xs'
                ]"
                [style.background-color]="searchItem.color"
                [style.border-color]="searchItem.color"
                [innerHTML]="searchItem.shortName | highlight: searchText"
                aria-hidden="true"></div>
        </ng-container>
    </div>

    <div class="ml-3.5">
        <ng-container *ngIf="searchName">
            <span class="sr-only">{{ searchName }}</span>
            <div
                class="flex-align-center flex"
                [innerHTML]="searchName | highlight: searchText"
                aria-hidden="true"></div>
        </ng-container>

        <div
            class="flex-align-center flex text-xs font-medium leading-4 text-grey-zambezy dark:text-contrast-yellow"
            *ngIf="searchItem?.desc && env.EXPLORE?.SHOW_MUNICIPALITY_NAME">
            {{ searchItem.desc }}
        </div>
    </div>
</button>
